import { render, staticRenderFns } from "./FaqsSuppliers.vue?vue&type=template&id=ebb16928&scoped=true&"
import script from "./FaqsSuppliers.vue?vue&type=script&lang=js&"
export * from "./FaqsSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb16928",
  null
  
)

export default component.exports